export const setOrderHistory = (data) => ({
    type: 'SET_ORDER_HISTORY',
    data
});